import {
  Box,
  HStack,
  Header,
  Text as TextBase,
  VStack,
  makeUclComponent,
} from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Link from 'components/link';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive, spacing } from 'styles/constants';

import { LoyaltyLoader } from '../loyalty-loader';

export const LoadingAnimation = LoyaltyLoader.withConfig({
  height: '50%',
  width: '50%',
});

export const MainImage = Picture.withConfig({
  alignSelf: 'center',
  objectFitContain: true,
});

const TextBlock = SanityBlockRenderer.withConfig({
  textProps: {
    fontSize: 'md',
    lineHeight: 'md',
  },
  linkProps: {
    fontSize: 'md',
    lineHeight: 'md',
    underline: true,
  },
});

export const Text = TextBlock.withConfig({
  marginTop: 0,
  textProps: {
    textAlign: 'center',
  },
});

export const InstructionDateText = TextBlock;

export const Title = Header.withConfig({
  variant: 'headerTwo',
  fontSize: '2xl',
  lineHeight: 'lg',
  margin: 0,
  marginTop: '$6',
  textAlign: 'center',
  focusable: true,
});

export const Button = makeUclComponent(ActionButton).withConfig({
  paddingTop: spacing.$2_5,
  paddingBottom: spacing.$2_5,
  paddingX: '$12',
  marginX: { base: 0, md: '$5' },
});

export const StyledLink = makeUclComponent(Link).withConfig({
  alignSelf: 'center',
  color: primitive.$fieryRed,
  isUnderlined: true,
  isInline: true,
});

export const TransactionInputFormContainer = HStack.withConfig({
  justifyContent: 'center',
  space: '$2',
});

export const TransactionDateInputFormContainer = VStack.withConfig({
  marginTop: '$6',
  marginBottom: '$10',
  space: '$2',
});

export const EarnedPointsWrapper = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '$2',
  marginBottom: '$6',
});

export const EarnedPointsText = TextBase.withConfig({
  fontFamily: 'heading',
  fontSize: 'lg',
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$8',
  height: '$8',
  marginTop: 0,
  marginRight: spacing.$1_5,
  marginBottom: 0,
  marginLeft: '$2',
});

export const ClaimsPointContent = Box.withConfig({
  margin: '$1',
});
